import { createSlice } from "@reduxjs/toolkit";

const favouriteProductsSlice = createSlice({
    name: 'favouriteProducts',
    initialState: {
        products: [],
    },
    reducers: {
        setFavouriteProducts: (state, action) => {
            state.products = action.payload;
        }
    }
});

export const { setFavouriteProducts,} = favouriteProductsSlice.actions;
export default favouriteProductsSlice.reducer;